// extracted by mini-css-extract-plugin
module.exports = {"iconBoxes":"TwoColTextImage_iconBoxes__JCA89","iconBoxWrapper":"TwoColTextImage_iconBoxWrapper__c_GeQ","imageWrapper":"TwoColTextImage_imageWrapper__k7hUI"};